import React, { useMemo, useCallback, useEffect } from 'react'
import { css } from "glamor";
import Page from '../library/Page';
import { Tab } from 'semantic-ui-react'
import { matchPath, useLocation } from "react-router";
import { useDispatch } from "react-redux";
import { replace } from "connected-react-router";
import FinancePurchasesContainer from './FinancePurchasesContainer';
import FinanceSubscriptionsContainer from './FinanceSubscriptionsContainer';
import InvoicesListContainer from '../invoices/InvoicesListContainer';

const menuOptions = { secondary: true, pointing: true }
const financePageClass = css({
  fontFamily: "Montserrat, sans-serif",
  width: "100%",
  maxWidth: "100%",
  overflowX: "hidden",
  ".ui.secondary.pointing.menu": {
    display: "flex",
    maxWidth: "100%",
    overflowX: "auto",
    overflowY: "hidden",
    WebkitOverflowScrolling: "touch",
    scrollbarWidth: "none",
    marginBottom: 14,
    paddingBottom: 1,
    borderBottomColor: "#E2E8F0 !important",
    borderBottomWidth: "0.6px !important",
  },
  ".ui.secondary.pointing.menu::-webkit-scrollbar": {
    display: "none",
  },
  ".ui.secondary.pointing.menu .item": {
    flex: "0 0 auto",
    whiteSpace: "nowrap",
    height: 38,
    padding: "0 10px !important",
    color: "#64748B !important",
    fontFamily: "Montserrat, sans-serif !important",
    fontSize: "16px !important",
    fontWeight: "600 !important",
    lineHeight: "20px !important",
    borderBottomWidth: "1.8px !important",
    borderBottomColor: "transparent !important",
    marginBottom: "-0.6px !important",
  },
  ".ui.secondary.pointing.menu .active.item": {
    color: "#0F172A !important",
    fontWeight: "600 !important",
    borderBottomColor: "#0F172A !important",
  },
  ".ui.tab": {
    maxWidth: "100%",
    background: "#FFFFFF",
    padding: "18px 0",
  },
  "@media(max-width: 640px)": {
    ".ui.secondary.pointing.menu": {
      marginLeft: -4,
      marginRight: -4,
      paddingLeft: 4,
      paddingRight: 4,
    },
    ".ui.secondary.pointing.menu .item": {
      paddingLeft: "10px !important",
      paddingRight: "10px !important",
    },
    ".ui.tab": {
      padding: "18px 0",
    },
  },
});
const panes = [
  {
    menuItem: 'Minhas assinaturas',
    path: '/finance/subscriptions',
    render: () => <FinanceSubscriptionsContainer />
  },
  {
    menuItem: 'Minhas compras',
    path: '/finance/purchases',
    render: () => <FinancePurchasesContainer />
  },
  {
    menuItem: 'Notas Fiscais',
    path: '/finance/invoices',
    render: () => <InvoicesListContainer />
  },
]

export default function FinancePage() {
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    document.body.classList.add("lms-finance-page");
    return () => document.body.classList.remove("lms-finance-page");
  }, []);

  const currentPaneIndex = useMemo(() => {
    const index = panes.findIndex(({ path }) => !!matchPath(pathname, { path }));
    return index === -1 ? 0 : index;
  }, [pathname]);

  const tabChangeHandler = useCallback((_, { activeIndex, panes }) =>
    dispatch(replace(panes[activeIndex].path))
    , [dispatch]);

  return (
    <Page title="Financeiro">
      <div className={financePageClass}>
        <Tab
          activeIndex={currentPaneIndex}
          onTabChange={tabChangeHandler}
          menu={menuOptions}
          panes={panes}
        />
      </div>
    </Page>
  )
}
